// extracted by mini-css-extract-plugin
export default {"container":"Login_container__IwEN2","form":"Login_form__Cfdau","passwordRecovery":"Login_passwordRecovery__BVoCg","underline":"Login_underline__4mK6C"};